import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefono: '',
    veicolo: '',
    servizio: '',
    messaggio: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d63imidsi3r5mpi9uvlg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          telefono: '',
          veicolo: '',
          servizio: '',
          messaggio: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <section id="contatti" className="py-12 sm:py-16 md:py-24 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16">
          {/* Left Side - Info */}
          <div>
            <div className="inline-block mb-4 md:mb-6">
              <span className="inline-block px-4 sm:px-6 py-2 border-2 border-black bg-white text-black font-bold text-xs tracking-widest rounded-full uppercase">
                Contatti
              </span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-bold text-black mb-4 md:mb-8">
              Prenota il Tuo<br />Intervento
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-8 md:mb-12">
              Compila il form per richiedere un preventivo gratuito o per prenotare un intervento. Ti risponderò nel più breve tempo possibile.
            </p>

            {/* Contact Info */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4 sm:gap-6 md:gap-8">
              <div className="flex items-start">
                <div className="w-10 sm:w-12 md:w-14 h-10 sm:h-12 md:h-14 rounded-full bg-[#E31E24] flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-white text-lg sm:text-xl md:text-2xl"></i>
                </div>
                <div className="ml-4 md:ml-6">
                  <h4 className="text-sm sm:text-base md:text-lg font-bold text-black mb-1 md:mb-2">Telefono</h4>
                  <a href="tel:+393518312394" className="text-sm sm:text-base text-gray-700 hover:text-[#E31E24] transition-colors duration-300 cursor-pointer">
                    +39 351 831 2394
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 sm:w-12 md:w-14 h-10 sm:h-12 md:h-14 rounded-full bg-[#E31E24] flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-white text-lg sm:text-xl md:text-2xl"></i>
                </div>
                <div className="ml-4 md:ml-6">
                  <h4 className="text-sm sm:text-base md:text-lg font-bold text-black mb-1 md:mb-2">Email</h4>
                  <a href="mailto:metamorfosi.preparazioni@gmail.com" className="text-sm sm:text-base text-gray-700 hover:text-[#E31E24] transition-colors duration-300 cursor-pointer">
                    metamorfosi.preparazioni@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 sm:w-12 md:w-14 h-10 sm:h-12 md:h-14 rounded-full bg-[#E31E24] flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-line text-white text-lg sm:text-xl md:text-2xl"></i>
                </div>
                <div className="ml-4 md:ml-6">
                  <h4 className="text-sm sm:text-base md:text-lg font-bold text-black mb-1 md:mb-2">WhatsApp</h4>
                  <a href="https://wa.me/393518312394" target="_blank" rel="noopener noreferrer" className="text-sm sm:text-base text-gray-700 hover:text-[#E31E24] transition-colors duration-300 cursor-pointer">
                    Chatta con me
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 sm:w-12 md:w-14 h-10 sm:h-12 md:h-14 rounded-full bg-[#E31E24] flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-white text-lg sm:text-xl md:text-2xl"></i>
                </div>
                <div className="ml-4 md:ml-6">
                  <h4 className="text-sm sm:text-base md:text-lg font-bold text-black mb-1 md:mb-2">Orari</h4>
                  <p className="text-sm sm:text-base text-gray-700">Lun - Ven: 8:00 - 19:00</p>
                  <p className="text-sm sm:text-base text-gray-700">Sabato: 8:00 - 13:00</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="bg-white rounded-2xl md:rounded-3xl p-5 sm:p-6 md:p-10 shadow-lg md:shadow-xl">
            <form id="contact-form" onSubmit={handleSubmit} data-readdy-form>
              <div className="space-y-4 md:space-y-6">
                <div>
                  <label htmlFor="nome" className="block text-xs sm:text-sm font-semibold text-black mb-1 md:mb-2">
                    Nome e Cognome *
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                    className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-200 rounded-lg focus:border-[#E31E24] focus:outline-none transition-colors duration-300 text-sm"
                    placeholder="Mario Rossi"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-xs sm:text-sm font-semibold text-black mb-1 md:mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-200 rounded-lg focus:border-[#E31E24] focus:outline-none transition-colors duration-300 text-sm"
                    placeholder="mario.rossi@email.it"
                  />
                </div>

                <div>
                  <label htmlFor="telefono" className="block text-xs sm:text-sm font-semibold text-black mb-1 md:mb-2">
                    Telefono *
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    required
                    className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-200 rounded-lg focus:border-[#E31E24] focus:outline-none transition-colors duration-300 text-sm"
                    placeholder="+39 312 345 6789"
                  />
                </div>

                <div>
                  <label htmlFor="veicolo" className="block text-xs sm:text-sm font-semibold text-black mb-1 md:mb-2">
                    Veicolo (Marca e Modello)
                  </label>
                  <input
                    type="text"
                    id="veicolo"
                    name="veicolo"
                    value={formData.veicolo}
                    onChange={handleChange}
                    className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-200 rounded-lg focus:border-[#E31E24] focus:outline-none transition-colors duration-300 text-sm"
                    placeholder="es. Fiat Panda 2018"
                  />
                </div>

                <div>
                  <label htmlFor="servizio" className="block text-xs sm:text-sm font-semibold text-black mb-1 md:mb-2">
                    Servizio Richiesto *
                  </label>
                  <select
                    id="servizio"
                    name="servizio"
                    value={formData.servizio}
                    onChange={handleChange}
                    required
                    className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-200 rounded-lg focus:border-[#E31E24] focus:outline-none transition-colors duration-300 text-sm cursor-pointer"
                  >
                    <option value="">Seleziona un servizio</option>
                    <option value="Tagliandi">Tagliandi</option>
                    <option value="Impianto Frenante">Impianto Frenante</option>
                    <option value="Diagnosi">Diagnosi</option>
                    <option value="Manutenzione">Manutenzione</option>
                    <option value="Altro">Altro</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="messaggio" className="block text-xs sm:text-sm font-semibold text-black mb-1 md:mb-2">
                    Messaggio
                  </label>
                  <textarea
                    id="messaggio"
                    name="messaggio"
                    value={formData.messaggio}
                    onChange={handleChange}
                    maxLength={500}
                    rows={3}
                    className="w-full px-3 sm:px-4 py-2.5 sm:py-3 border-2 border-gray-200 rounded-lg focus:border-[#E31E24] focus:outline-none transition-colors duration-300 resize-none text-sm"
                    placeholder="Descrivi brevemente la tua richiesta..."
                  ></textarea>
                  <p className="text-xs text-gray-500 mt-1">Massimo 500 caratteri</p>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#E31E24] text-white font-bold text-sm sm:text-base py-3 sm:py-4 rounded-full hover:bg-[#c41a1f] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? 'INVIO IN CORSO...' : 'INVIA RICHIESTA'}
                </button>

                {submitStatus === 'success' && (
                  <div className="bg-green-50 border-2 border-green-500 text-green-700 px-3 sm:px-4 py-2 sm:py-3 rounded-lg text-xs sm:text-sm">
                    <strong>Grazie!</strong> La tua richiesta è stata inviata con successo. Ti contatteremo presto.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border-2 border-red-500 text-red-700 px-3 sm:px-4 py-2 sm:py-3 rounded-lg text-xs sm:text-sm">
                    <strong>Errore!</strong> Si è verificato un problema. Riprova o contattaci direttamente.
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
